//common.js 用于定义公共接口

import req from './http.js';
import urls from '../utils/config';
const loginUrl = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_LOGINURL: urls['loginUrl']
const loginSjUrl = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_LOGINSJURL: urls['loginSjUrl']

//定义接口

//在这里定义接口暴露出去给组件使用
export const getSmscode = params => req('post', '/passenger/verifyCode/getSmscode', params, {
  baseURL: loginUrl,
}); // 获取验证码
export const LOGIN = params => req('post', '/app/userCenter/user/login', params, {
  baseURL: loginUrl,
}); // 登录

export const LOGINSJ = params => req('post', '/driver/sys/login', params, {
  baseURL: loginSjUrl,
}); // 代驾司机登录
export const getSmsCodeSJ = params => req('post', '/driver/verifyCode/getSmsCode', params, {
  baseURL: loginSjUrl,
}); // 代驾司机验证码
export const registerSJ = params => req('post', '/driver/sys/register', params, {
  baseURL: loginSjUrl,
}); // 代驾司机注册
//这里使用了箭头函数，转换一下写法：
// export const LOGIN=function(params){
//   return req('post','/getCarsByCriteria',params)
// }
